import ClusterWaveformWidget from '../components/ClusterWaveformWidget';
import { WIDGET_DATA_CONTRACTS } from './dataContracts';

export const CLUSTER_WAVEFORM = {
  id: 'clusterWaveform', name: 'Cluster Waveform Comparison',
  description: 'Compare cluster columns grouped by primary channel with adjustable reference lines',
  component: ClusterWaveformWidget, icon: '▥', category: 'visualization',
  defaultSize: { width: 820, height: 650 }, minWidth: 350, minHeight: 300,
  requiredData: ['clusters'], dataContract: WIDGET_DATA_CONTRACTS.clusterWaveform, order: 29,
};
